import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { DepartmentService } from '../../_services/department.service';

@Component({
  selector: 'app-department-tree-2',
  templateUrl: './department-tree-2.component.html',
  styleUrls: ['./department-tree-2.component.scss'],
})
export class DepartmentTree2Component implements OnInit {

  public AllowParentSelection = true;
  public RestructureWhenChildSameName = true;
  public ShowFilter = true;
  public Disabled = false;
  public FilterPlaceholder = 'Tìm kiếm theo tên phòng ban';
  public MaxDisplayed = 500;
  public departments: Array<any>;
  @Output() changeDepartment = new EventEmitter();
  @Input() simpleSelected: any;
  @Input() multipleSelected: any;
  @Input() checkMultiple: boolean;

  constructor(private departmentService: DepartmentService) {}

  select() {
    this.changeDepartment.emit(this.simpleSelected);
  }
  selectMultiple() {
    this.changeDepartment.emit(this.multipleSelected);
    setTimeout(() => {
      $('.pull-left.selected-item-item.btn.btn-default.btn-xs').css({
        border: '1px solid rgba(145, 142, 142, 0.52)',
        color: 'black',
      });
      $('.close').css({ 'padding-top': '0px', color: 'red' });
    }, 100);
  }
  ngOnInit(): void {
    this.getDepartments();
  }
  getDepartments() {
    this.departmentService.getDepartmentPermission().subscribe((response) => {
      if (response.success) {
        this.departments = response.data.departments;
        this.departments = this.buildTree(this.departments);
      }
    });
  }
  buildTree(arr) {
    let tree = [], arrElem: any, mappedElem: any;
    const mappedArr = {};

    if (!this.checkMultiple) {
      tree.push({ _id: -999, name: '--- Chọn ---' });
    }
    for (let i = 0; i < arr.length; i++) {
      arrElem = arr[i];
      mappedArr[arrElem._id] = arrElem;
      mappedArr[arrElem._id]['children'] = [];
    }
    for (const _id in mappedArr) {
      if (mappedArr.hasOwnProperty(_id)) {
        mappedElem = mappedArr[_id];
        if (mappedElem.parent) {
          if (mappedArr[mappedElem['parent']]) {
            mappedArr[mappedElem['parent']]['children'].push(mappedElem);
          }
        } else {
          tree.push(mappedElem);
        }
      }
    }
    return tree;
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_custom/department-tree-2/department-tree-2.component.ts